import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.scout-report-point-issue-form', () => {
  void import('./internal/scout-report-point-issue-form')
    .then(({ default: Component }) => Component());
});
